// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"4ccffb17","787":"755e9ffe"}[chunkId] + ".chunk.js";
};